import { createPinia } from "pinia"
import PrimeVue from "primevue/config"
import ToastService from "primevue/toastservice"
import { createApp } from "vue"
import App from "./App.vue"
import "./main.scss"
import router from "./router"

const app = createApp(App)

app.use(createPinia())
app.use(PrimeVue)
app.use(ToastService)
app.use(router)

app.mount("#app")
